import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AclService } from '../services/acl.service';

// customized ng-if directive
@Directive({
  selector: '[hasMinRole]',
  standalone: false
})
export class HasMinRoleDirective {
  constructor(
    private aclService: AclService,
    private authService: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() hasMinRoleElse?: TemplateRef<unknown>;

  @Input() set hasMinRole(role: string) {
    this.aclService.HasMinimumRoleByName(this.authService.getCurrentUserId(), role).subscribe(
      hasRole => {
        if (hasRole) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (this.hasMinRoleElse) {
          // show backup "else" template if one is defined
          this.viewContainer.createEmbeddedView(this.hasMinRoleElse);
        } else {
          this.viewContainer.clear();
        }
      },
      err => {
        this.viewContainer.clear();
      }
    );
  }
}
